import { useEffect, useState } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function ClusterPage() {
  const [wallets, setWallets] = useState({});
  const [edges, setEdges] = useState({}); // связи

  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const p = msg.payload || {};
        const from = p.from;
        const to = p.to;
        const contract = p.to;

        if (!from) return;

        const now = Date.now();

        // 🔥 обновление кошельков
        setWallets((prev) => {
          const old = prev[from] || {
            total: 0,
            last: now,
            sameContract: 0,
            contract,
          };

          let sameContract = old.sameContract;
          if (old.contract === contract) sameContract += 1;

          return {
            ...prev,
            [from]: {
              ...old,
              total: old.total + 1,
              last: now,
              sameContract,
              contract,
            },
          };
        });

        // 🔥 связи (кто взаимодействует с одним контрактом)
        if (contract) {
          setEdges((prev) => {
            const list = prev[contract] || [];
            return {
              ...prev,
              [contract]: [...new Set([...list, from])],
            };
          });
        }
      } catch {}
    };

    return () => ws.close();
  }, []);

  // 🔥 поиск кластеров
  const clusters = Object.entries(edges)
    .map(([contract, wallets]) => {
      return {
        contract,
        wallets,
        size: wallets.length,
      };
    })
    .filter((c) => c.size > 3)
    .sort((a, b) => b.size - a.size)
    .slice(0, 20);

  const getType = (c) => {
    if (c.size > 20) return "🔥 Massive Coordination";
    if (c.size > 10) return "🚨 Coordinated Attack";
    if (c.size > 5) return "⚠️ Suspicious Cluster";
    return "• Small Group";
  };

  const getInsight = (c) => {
    if (c.size > 20)
      return "Large number of wallets interacting with same contract";
    if (c.size > 10)
      return "Possible coordinated bot activity";
    if (c.size > 5)
      return "Clustered behavior detected";
    return "Low coordination";
  };

  return (
    <div style={{ minHeight: "100vh", background: "#000", color: "#fff" }}>
      <Header />

      <div style={{ padding: 24 }}>
        <h1 style={{ fontSize: 32, marginBottom: 10 }}>
          🧠 Cluster Detection
        </h1>

        <p style={{ color: "#aaa", marginBottom: 20 }}>
          Detect coordinated wallet behavior
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {clusters.map((c, i) => (
            <div
              key={c.contract}
              style={{
                padding: 16,
                border: "1px solid #222",
                borderRadius: 10,
                background: "#111",
              }}
            >
              <div style={{ fontSize: 12, color: "#777" }}>
                Contract: {c.contract}
              </div>

              <div style={{ fontSize: 20, margin: "6px 0" }}>
                #{i + 1} {getType(c)}
              </div>

              <div style={{ color: "#6bc1ff" }}>
                Wallets: {c.size}
              </div>

              <div style={{ fontSize: 13, color: "#aaa" }}>
                {c.wallets.slice(0, 5).join(", ")}...
              </div>

              <div style={{ marginTop: 8, color: "#9cff9c", fontSize: 13 }}>
                Insight: {getInsight(c)}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}